function SSShareWidgets(config){
  this.gaCategory = config.gaCategory;
  this.container = config.container;
}

SSShareWidgets.prototype.loadTwWidget = function(){
  window.twttr = (function (d, s, id) {
    var t, js, fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) {
      return;
    }
    js = d.createElement(s);
    js.id = id;
    js.src = "//platform.twitter.com/widgets.js";
    fjs.parentNode.insertBefore(js, fjs);
    return window.twttr || (t = {
      _e: [],
      ready: function (f) {
        t._e.push(f);
      }
    });
  }(document, "script", "twitter-wjs"));

  var shareWidget = this;
  window.twttr.ready(function (twttr) {
    var that = shareWidget;
    twttr.events.bind('tweet', function (event) {
      if (event) {
        $.slideshareEventManager.trackEvent(that.gaCategory + 'twitter_share');
      }
    });
    twttr.events.bind('click', function(event){
      $.slideshareEventManager.trackEvent(that.gaCategory + 'twitter_click');
    });
  });
};

SSShareWidgets.prototype.loadLIwidget = function(){
  var LIsrc = document.location.protocol + '//platform.linkedin.com/in.js?async=true';

  if(typeof window.IN === "undefined"){
    $.getScript(LIsrc, function() {
      // Now the LinkedIn "IN" object should exist.
        typeof(window.IN) !== 'undefined' && window.IN.init({
          api_key: "y4wa9oe4c6nu",
          credentials_cookie: true,
          authorize: true,
          entropy: Math.floor(Math.random() * 10000)
        });
    });
  }else {
      window.IN.parse(document);
  }

  const that = this;

  window.socialScreenLinkedInSuccess = function(){
    $.slideshareEventManager.trackEvent(that.gaCategory + 'li_share');
  };
};

SSShareWidgets.prototype.loadGplusWidget = function(){
   window.___gcfg = {
     lang: 'en-US'
   };
   (function() {
     var po = document.createElement('script');
     po.type = 'text/javascript';
     po.async = true;
     po.src = 'https://apis.google.com/js/plusone.js';
     var s = document.getElementsByTagName('script')[0];
     s.parentNode.insertBefore(po, s);
   })();
  const that = this;
  window.socialScreenPlusOneSuccess = function(){
    $.slideshareEventManager.trackEvent(that.gaCategory + 'gplus_share');
  };
};

SSShareWidgets.prototype.loadPinItWidget = function(){
  (function(d){
    var f = d.getElementsByTagName('SCRIPT')[0], p = d.createElement('SCRIPT');
    p.type = 'text/javascript';
    p.async = true;
    p.src = '//assets.pinterest.com/js/pinit.js';
    f.parentNode.insertBefore(p, f);
  }(document));

  const that = this;
  this.container.find('.pinit-btn').click(function(){
    $.slideshareEventManager.trackEvent(that.gaCategory + 'pinit_share');
  });
};

SSShareWidgets.prototype.sendMail = function(config){
  var isSending = false;
  var emailSendButton = config.sendButton;
  if(!isSending) {
    emailSendButton.trigger('mailSending');
    isSending = true;
    $.post(config.postTo, {
      data: config.params,
      dataType: 'json'
    })
    .success(function(data) {
      isSending = false;
      if(data.isSuccess) {
        emailSendButton.trigger('mailSendSuccess');
      } else {
        emailSendButton.trigger('mailSendFailure', data);
      }
    })
    .error(function(xhr, status, error) {
      isSending = false;
      emailSendButton.trigger('mailSendError');
    });
  }
};

export default SSShareWidgets
